import { QueryFunctionContext } from '@tanstack/react-query';

import { GET_WITH_CREDENTIALS, POST_WITH_CREDENTIALS } from '~/api';
import { JiraIssueTransitionsApiUrl } from '~/api/urls';
import { IJiraTransition } from '~/domain/IJiraTransition';
import { JiraList } from '~/domain/JiraList';

// jira does not have an api for transition by status and typeName (issueType)
// so in order to cache this request, we add these 2 params as queryKey so react query can cache the request properly
export const getTransitions = async (issueId: string, context: QueryFunctionContext<[string, { status: string, typeName: string }]>) => {
  const url = JiraIssueTransitionsApiUrl.expand({
    issueId,
    sortByOpsBarAndStatus: true,
  });
  return await GET_WITH_CREDENTIALS<JiraList<{ transitions: IJiraTransition[] }>>(url);
}

export const updateTransition = async (issueId: string, transition: IJiraTransition) => {
  const url = JiraIssueTransitionsApiUrl.expand({
    issueId,
  });
  await POST_WITH_CREDENTIALS(url, { transition });
}
